(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("aws_amplify_core"), require("aws_amplify_cache"));
	else if(typeof define === 'function' && define.amd)
		define("aws_amplify_analytics", ["aws_amplify_core", "aws_amplify_cache"], factory);
	else if(typeof exports === 'object')
		exports["aws_amplify_analytics"] = factory(require("aws_amplify_core"), require("aws_amplify_cache"));
	else
		root["aws_amplify_analytics"] = factory(root["aws_amplify_core"], root["aws_amplify_cache"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE__1__, __WEBPACK_EXTERNAL_MODULE__9__) {
return 